import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import QuantityBasisValueTxtBox from './QtyBasisValueTxtBox';
import { TextField } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { StyledRadio } from '../../../../../utils/designComponents/StyledRadio';

const entryNames = [
  { label: 'mkt', tactic: 'MARKET_ORDER' },
  { label: 'this candle', tactic: 'CANDLE_BREAK' },
  { label: 'previous candle', tactic: 'CANDLE_BREAK' },
  { label: 'lmt', tactic: 'LIMIT_ORDER' },
];

export default function QuickEntries({
  top,
  dispatchTop,
  marketOrder,
  marketOrderEnabled,
  setMarketOrderEnabled,
  dispatchMarketOrder,
  limitOrder,
  limitOrderEnabled,
  setLimitOrderEnabled,
  dispatchLimitOrder,
  candleBreak,
  candleBreakEnabled,
  setCandleBreakEnabled,
  dispatchCandleBreak,
  data,
  defaultQtyBasisValue,
}) {
  const [qtyBasisValue, setQtyBasisValue] = useState(defaultQtyBasisValue); //if user has default value, then use it

  useEffect(() => {
    //console.log("qtybasis: "+defaultQtyBasisValue);
    setQtyBasisValue(defaultQtyBasisValue);
  }, [defaultQtyBasisValue]);
  let entryTactics = data['entryTactics'];

  useEffect(() => {
    if (entryTactics['MARKET_ORDER'] !== undefined) {
      setQtyBasisValue(entryTactics['MARKET_ORDER']['quantityBasisValue']);
    } else if (entryTactics['LIMIT_ORDER'] !== undefined) {
      setQtyBasisValue(entryTactics['LIMIT_ORDER']['quantityBasisValue']);
    } else if (entryTactics['CANDLE_BREAK'] !== undefined) {
      setQtyBasisValue(entryTactics['CANDLE_BREAK']['quantityBasisValue']);
    }
  }, [entryTactics]);

  return (
    <Grid item container>
      {/* <Grid item xs={12}>
                <Typography style={{fontSize: 12}}><u>ENTRIES</u></Typography>
            </Grid> */}
      {entryNames.map((value, index) => {
        let entryNameEnabled = false;
        if (value.label === 'mkt' && marketOrderEnabled) {
          entryNameEnabled = true;
        } else if (value.label === 'lmt' && limitOrderEnabled) {
          entryNameEnabled = true;
        } else if (value.label === 'this candle' && candleBreakEnabled) {
          if (candleBreak.waitUntilCurrentCandleCloses) {
            entryNameEnabled = true;
          }
        } else if (value.label === 'previous candle' && candleBreakEnabled) {
          if (!candleBreak.waitUntilCurrentCandleCloses) {
            entryNameEnabled = true;
          }
        }
        return (
          <Grid item xs={3} key={value.label}>
            <Button
              key={value.label}
              style={{
                fontSize: 10,
                backgroundColor: entryNameEnabled ? 'lightgray' : 'white',
                color: entryNameEnabled ? 'blue' : 'black',
                height: '100%',
                width: '100%',
              }}
              value={value}
              onClick={(ev) => {
                if (marketOrderEnabled) {
                  setMarketOrderEnabled(false);
                } else if (limitOrderEnabled) {
                  setLimitOrderEnabled(false);
                } else if (candleBreakEnabled) {
                  setCandleBreakEnabled(false);
                }
                if (value.label === 'mkt') {
                  setMarketOrderEnabled(true);
                  dispatchMarketOrder({ quantityBasisValue: qtyBasisValue });
                } else if (value.label === 'lmt') {
                  setLimitOrderEnabled(true);
                  dispatchLimitOrder({ quantityBasisValue: qtyBasisValue });
                } else if (value.label === 'this candle') {
                  setCandleBreakEnabled(true);
                  dispatchCandleBreak({
                    waitUntilCurrentCandleCloses: true,
                    quantityBasisValue: qtyBasisValue,
                  });
                } else if (value.label === 'previous candle') {
                  setCandleBreakEnabled(true);
                  dispatchCandleBreak({
                    waitUntilCurrentCandleCloses: false,
                    quantityBasisValue: qtyBasisValue,
                  });
                }
              }}
            >
              {value.label}
            </Button>
          </Grid>
        );
      })}
      <div className="m-2">
        <Grid item xs={12} container>
          <Grid item xs={marketOrderEnabled ? 7 : 6}>
            <QuantityBasisValueTxtBox
              top={top}
              qtyBasis={top.quantityBasis}
              dispatchTop={dispatchTop}
              entryTactics={data['entryTactics']}
              dispatchMarketOrder={dispatchMarketOrder}
              dispatchLimitOrder={dispatchLimitOrder}
              dispatchCandleBreak={dispatchCandleBreak}
              qtyBasisValue={qtyBasisValue}
              setQtyBasisValue={setQtyBasisValue}
            />
          </Grid>
          <Grid item xs={marketOrderEnabled ? 5 : 6}>
            {limitOrderEnabled ? (
              <LimitOrderFields
                limitOrder={limitOrder}
                dispatchLimitOrder={dispatchLimitOrder}
              />
            ) : candleBreakEnabled ? (
              <CandleBreakFields
                candleBreak={candleBreak}
                dispatchCandleBreak={dispatchCandleBreak}
              />
            ) : null}
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
}

function LimitOrderFields({ limitOrder, dispatchLimitOrder }) {
  const [useOffset, setUseOffset] = useState(true);
  const [limitPrice, setLimitPrice] = useState(limitOrder.limitPrice);
  const [offset, setOffset] = useState(limitOrder.offsetFromSetupPrice);
  useEffect(() => {
    setLimitPrice(limitOrder.limitPrice);
    setOffset(limitOrder.offsetFromSetupPrice);
  }, [limitOrder]);

  return (
    <Grid container>
      <Grid item xs={4}>
        <RadioGroup
          row
          aria-label="instrument"
          name="instrument"
          value={useOffset ? 'useOffset' : 'useLimit'}
          onChange={(ev) => {
            if (useOffset) {
              //now will not be use offset
              dispatchLimitOrder({ offsetFromSetupPrice: 0 });
            } else {
              dispatchLimitOrder({ limitPrice: 0 });
            }
            setUseOffset(ev.target.value === 'useOffset');
          }}
        >
          <Grid item xs={6}>
            <FormControlLabel
              value="useOffset"
              control={<StyledRadio />}
              label={<Typography style={{ fontSize: 10 }}>offset</Typography>}
              labelPlacement={'bottom'}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              value="useLimit"
              control={<StyledRadio />}
              label={<Typography style={{ fontSize: 10 }}>lmt</Typography>}
              labelPlacement={'bottom'}
            />
          </Grid>
        </RadioGroup>
      </Grid>
      <Grid item xs={2} />
      {!useOffset ? (
        <Grid item xs={4}>
          <TextField
            size={'small'}
            label={
              <Typography style={{ fontSize: 10 }}> lmt price </Typography>
            }
            //variant="outlined"
            value={limitPrice}
            onChange={(ev) => {
              setLimitPrice(ev.target.value);
            }}
            onBlur={(ev) => dispatchLimitOrder({ limitPrice: ev.target.value })}
            //required
          />
        </Grid>
      ) : (
        <Grid item xs={4}>
          <TextField
            size={'small'}
            label={<Typography style={{ fontSize: 13 }}> $ </Typography>}
            //variant="outlined"
            value={offset}
            onChange={(ev) => {
              setOffset(ev.target.value);
            }}
            onBlur={(ev) =>
              dispatchLimitOrder({ offsetFromSetupPrice: ev.target.value })
            }
            //required
          />
        </Grid>
      )}
    </Grid>
  );
}

function CandleBreakFields({ candleBreak, dispatchCandleBreak }) {
  const [candleDuration, setCandleDuration] = useState(
    candleBreak.candleDuration
  );
  const [breakBy, setBreakBy] = useState(candleBreak.breakBy);

  useEffect(() => {
    setCandleDuration(candleBreak.candleDuration);
    setBreakBy(candleBreak.breakBy);
  }, [candleBreak]);

  return (
    <Grid container>
      <Grid item xs={1} />
      <Grid item xs={3}>
        <TextField
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}> candle duration </Typography>
          }
          //variant="outlined"
          value={candleDuration}
          onChange={(ev) => {
            setCandleDuration(ev.target.value);
          }}
          onBlur={(ev) =>
            dispatchCandleBreak({ candleDuration: ev.target.value })
          }
          //required
        />
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={3}>
        <TextField
          size={'small'}
          label={<Typography style={{ fontSize: 10 }}> break by </Typography>}
          //variant="outlined"
          value={breakBy}
          onChange={(ev) => {
            setBreakBy(ev.target.value);
          }}
          onBlur={(ev) => dispatchCandleBreak({ breakBy: ev.target.value })}
          //required
        />
      </Grid>
    </Grid>
  );
}
